<template>
  <div
    v-if="show"
    class="fixed inset-0 flex items-center justify-center bg-black/70 z-[999] px-4"
  >
    <div
      class="relative w-full max-w-lg bg-[#10172A] border border-[#80CBD4]/30 p-8 rounded-2xl shadow-[0_0_30px_rgba(128,203,212,0.2)] text-white text-center"
    >
      <!-- Title -->
      <h2 class="text-2xl sm:text-3xl font-black text-[#80CBD4] tracking-wide uppercase mb-4">
        {{ title }}
      </h2>

      <!-- Message -->
      <div class="text-white/90 text-sm sm:text-base mb-8 leading-relaxed" v-html="message"></div>

      <!-- Actions -->
      <div class="flex flex-col sm:flex-row gap-3 justify-center">
        <button
          @click="$emit('cancel')"
          class="px-8 py-3 bg-[#1B2D47] text-white font-bold rounded-xl hover:bg-[#1B2D47]/80 transition-all border border-white/10"
        >
          {{ cancelText === 'Cancel' ? $t('ConfirmationModal.Cancel') : cancelText }}
        </button>
        <button
          @click="$emit('confirm')"
          class="px-8 py-3 bg-gradient-to-r from-[#80CBD4] to-[#0090FF] text-black font-bold rounded-xl shadow-lg hover:brightness-110 transition-all"
        >
          {{ confirmText === 'Confirm' ? $t('ConfirmationModal.Confirm') : confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    title: String,
    message: String,
    confirmText: {
      type: String,
      default: "Confirm",
    },
    cancelText: {
      type: String,
      default: "Cancel",
    },
  },
};
</script>
